import { useState } from "react";
import { Form, Modal, Typography } from "antd";
import CustomSelect from "@/components/inputs/CustomSelect";

import { bindingEmployee } from "@/api/users";

const { Text } = Typography;

// Окно для добавления сотрудника к пользователю
const BindingEmployeeModal = ({
  list,
  user_uuid,
  visible,
  onSave,
  onCancel,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      await bindingEmployee({
        user_uuid,
        employee_uuid: values.employee_uuid,
      });

      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () =>
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });

  return (
    <Modal
      maskClosable={false}
      title="Привязать сотрудника к пользователю"
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText="Привязать"
      cancelText="Отмена"
      okButtonProps={{ loading: isLoading }}
    >
      <Form form={form} layout="vertical" onFinish={handleSave}>
        <Form.Item name="employee_uuid" label="Сотрудник">
          <CustomSelect
            placeholder="Начните вводить"
            options={list}
            showSearch
            allowClear
            fieldNames={{ value: "uuid" }}
            optionFilterProp="label"
          />
        </Form.Item>

        {error && <Text type="danger">{error}</Text>}
      </Form>
    </Modal>
  );
};

export default BindingEmployeeModal;
